import { Outlet, useParams } from "react-router-dom";
import Sidebar from "../SideMenu/sidemenu";
import Navbar from "../Navbar/navbar";
import "../../App.css";
import { useContext, useEffect, useState } from "react";
import { MyContext } from "../../context/context";
import StudentProfileSidebar from "../../studentProfile/Pages/Sidebar";
import AccessPending from "../AccessPending/AccessPending";
import AccessHold from "../AccessHold/AccessHold";
import AccessExpired from "../AccessExpired/AccessExpired";

const MainLayout = () => {
  const {
    showHelpDesk,
    setShowHelpDesk,
    isSubmitting,
    setIsSubmitting,
    showSubmissionForm,
    setShowSubmissionForm,
    activeProjectId,
  } = useContext(MyContext);

  const params = useParams();

  // USER DATA
  const [user] = useState(() => {
    const stored = localStorage.getItem("student");
    return stored ? JSON.parse(stored) : null;
  });

  const student = user?.student || {};

  // ---------------- PROJECT FORM ----------------
  const [projectFormData, setProjectFormData] = useState({
    UID: student.UID || "",
    name: student.studentName || "",
    email: student.email || "",
    projectId: activeProjectId || "",
    course: student.program === "tech-pro" ? "Tech Pro" : "Tech Smart" || "",
    htmlCode: "",
    cssCode: "",
    jsCode: "",
  });

  // Sync project ID when user clicks "Submit Project"
  useEffect(() => {
    if (activeProjectId) {
      setProjectFormData((prev) => ({
        ...prev,
        projectId: activeProjectId,
      }));

      setShowSubmissionForm(true);
    }
  }, [activeProjectId, setShowSubmissionForm]);

  // ---------------- HELP FORM ----------------
  const [helpFormData, setHelpFormData] = useState({
    UID: student.UID || "",
    name: student.studentName || "",
    email: student.email || "",
    phone: "",
    type: "portal",
    subject: "",
    description: "",
  });

  // Help Form Input Handler
  const handleHelpInputChange = (e) => {
    const { name, value } = e.target;
    setHelpFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit Help Form
  const handleHelpSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(process.env.REACT_APP_HELP_DESK, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(helpFormData),
      });

      const result = await response.json();

      if (result.success) {
        alert("Your query has been submitted successfully!");

        // Correct Reset
        setHelpFormData({
          UID: student.UID,
          name: student.studentName,
          email: student.email,
          phone: "",
          type: "portal",
          subject: "",
          description: "",
        });

        setShowHelpDesk(false);
      } else {
        alert("Failed to submit form. Please try again!");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  // ---------------- PROJECT FORM INPUT ----------------
  const handleProjectInputChange = (e) => {
    const { name, value } = e.target;
    setProjectFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Project Submit
  const handleProjectSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_PROJECT_SUBMIT}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(projectFormData),
      });

      const result = await response.json();

      if (result.success) {
        alert("Project submitted successfully!");

        // Correct Reset (with student data)
        setProjectFormData({
          UID: student.UID,
          name: student.studentName,
          email: student.email,
          projectId: activeProjectId,
          course:
            student.program === "tech-pro" ? "Tech Pro" : "Tech Smart" || "",

          htmlCode: "",
          cssCode: "",
          jsCode: "",
        });

        setShowSubmissionForm(false);
      } else {
        alert("Failed to submit project. Please try again!");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  // Sidebar Switch
  const sidebarExist = () => {
    if (params["*"].startsWith("profile")) {
      return <StudentProfileSidebar />;
    }
    return <Sidebar />;
  };

  const getLayout = (task) => {
    switch (task) {
      case "yet-to-give":
        return <AccessPending />;
      case "access-given":
        return (
          <div style={{ display: "flex", flexDirection: "row" }}>
            {sidebarExist()}

            <div style={{ flexGrow: 1 }}>
              <Outlet />

              {/* ---------- PROJECT SUBMISSION FORM ---------- */}
              {showSubmissionForm && (
                <div className="popup-overlay">
                  <div className="popup form-popup">
                    <div className="form-header">
                      <h3>Submit Your Project</h3>
                      <button
                        className="close-form"
                        onClick={() => setShowSubmissionForm(false)}
                      >
                        ×
                      </button>
                    </div>

                    <form onSubmit={handleProjectSubmit}>
                      <div className="form-row">
                        <div className="form-group">
                          <label>Full Name *</label>
                          <input
                            type="text"
                            value={projectFormData.name}
                            disabled
                          />
                        </div>

                        <div className="form-group">
                          <label>Email *</label>
                          <input
                            type="email"
                            value={projectFormData.email}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="form-row">
                        <div className="form-group">
                          <label>Project ID *</label>
                          <input
                            type="text"
                            value={projectFormData.projectId}
                            disabled
                          />
                        </div>

                        <div className="form-group">
                          <label>Enrolled Program *</label>
                          <input
                            type="text"
                            value={projectFormData.course}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <label>HTML Code *</label>
                        <textarea
                          name="htmlCode"
                          value={projectFormData.htmlCode}
                          onChange={handleProjectInputChange}
                          required
                        ></textarea>
                      </div>

                      <div className="form-group">
                        <label>CSS Code *</label>
                        <textarea
                          name="cssCode"
                          value={projectFormData.cssCode}
                          onChange={handleProjectInputChange}
                          required
                        ></textarea>
                      </div>

                      <div className="form-group">
                        <label>JavaScript Code *</label>
                        <textarea
                          name="jsCode"
                          value={projectFormData.jsCode}
                          onChange={handleProjectInputChange}
                          required
                        ></textarea>
                      </div>

                      <div className="form-actions">
                        <button
                          type="button"
                          className="cancel-btn"
                          onClick={() => setShowSubmissionForm(false)}
                        >
                          Cancel
                        </button>

                        <button
                          type="submit"
                          className="submit-form-btn"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Submit Project"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              {/* ---------- HELP DESK FORM ---------- */}
              {showHelpDesk && (
                <div className="popup-overlay">
                  <div className="popup form-popup">
                    <div className="form-header">
                      <h3>Help Desk - Submit Your Query</h3>
                      <button
                        className="close-form"
                        onClick={() => setShowHelpDesk(false)}
                      >
                        ×
                      </button>
                    </div>

                    <form onSubmit={handleHelpSubmit}>
                      <div className="form-row">
                        <div className="form-group">
                          <label>Full Name *</label>
                          <input
                            type="text"
                            name="name"
                            value={helpFormData.name}
                            onChange={handleHelpInputChange}
                            required
                          />
                        </div>

                        <div className="form-group">
                          <label>Email *</label>
                          <input
                            type="email"
                            name="email"
                            value={helpFormData.email}
                            onChange={handleHelpInputChange}
                            required
                          />
                        </div>

                        <div className="form-group">
                          <label>Phone *</label>
                          <input
                            type="tel"
                            name="phone"
                            value={helpFormData.phone}
                            placeholder="Provide working number"
                            onChange={handleHelpInputChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="form-group">
                        <label>What type of help is needed? *</label>
                        {/* <input
                      type="text"
                      name="subject"
                      value={helpFormData.subject}
                      onChange={}
                      required
                    /> */}
                        <select
                          onChange={handleHelpInputChange}
                          name="type"
                          type="help"
                        >
                          <option value="portal" selected>
                            Portal Help
                          </option>
                          <option value="subject">Subject Help</option>
                          <option value="payment-fee">Payment(Fee) Help</option>
                          <option value="referral">Referral Help</option>
                          <option value="others">Others</option>
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Subject *</label>
                        <input
                          type="text"
                          name="subject"
                          value={helpFormData.subject}
                          placeholder="Short title for your issue"
                          onChange={handleHelpInputChange}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Description *</label>
                        <textarea
                          name="description"
                          value={helpFormData.description}
                          placeholder="Write more information about your problem"
                          onChange={handleHelpInputChange}
                          required
                        ></textarea>
                      </div>

                      <div className="form-actions">
                        <button
                          type="button"
                          className="cancel-btn"
                          onClick={() => setShowHelpDesk(false)}
                        >
                          Cancel
                        </button>

                        <button
                          type="submit"
                          className="submit-form-btn"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Submitting..." : "Submit Query"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </div>
          </div>
        );

      case "hold-access":
        return <AccessHold />;

      case "access-expired":
        return <AccessExpired />;

      default:
        return null;
    }
  };

  // ---------------- RETURN UI ----------------
  return (
    <div className="main-layout">
      <Navbar />

      {getLayout(user?.student?.zavAccess || "")}
    </div>
  );
};

export default MainLayout;
